import { render, staticRenderFns } from "./error_alerte.vue?vue&type=template&id=80f87fee&scoped=true&"
import script from "./error_alerte.vue?vue&type=script&lang=js&"
export * from "./error_alerte.vue?vue&type=script&lang=js&"
import style0 from "./error_alerte.vue?vue&type=style&index=0&id=80f87fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f87fee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
